module.exports = __webpack_public_path__ + "img/09.122a0674.jpg";